/**
 * User-facing validation messages for the CPT-codes "Save Changes" button's
 * disabling conditions (see `disabled` in
 * `pages/worklists/singleOrder/cptCodes/components/CptCodesToolbar.tsx`).
 *
 * Each key maps 1:1 to a condition that can disable the button, so the same
 * message can be reused in tooltips, banners, toasts, or help text anywhere
 * in the app.
 *
 * @module saveChangesValidationMessages
 */
export enum SaveChangesValidationMessages {
  // No edits since the last save, so there is nothing to save
  NO_CHANGES_TO_SAVE = "No unsaved changes",

  // A save request is already in flight
  SAVE_IN_PROGRESS = "Save in progress",

  // Any row has an invalid value on a save-blocking field (dates, visits,
  // J-code, Auth #, or Filing Info)
  CPT_TABLE_HAS_ERRORS = "Invalid CPT table values",

  // CPT-table values (start/end date, auth #, total visits) differ from the
  // auth-letter values
  AUTH_LETTER_FIELD_MISMATCH = "CPT values do not match the auth letter",
}
